import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Row,
  Typography,
  List,
  Tooltip,
  Flex,
  Modal,
  Divider,
  Popconfirm,
  Skeleton,
} from "antd";
import { useEffect, useState, useContext } from "react";
import { IndexContext } from "../../../context/IndexContext";
import useFetch from "../../../hooks/useFetch";
import "../../../styles/Configuration/SiteView.css";
import SeuForm from "./SeuForm";
import SeuDetails from "./SeuDetails";

const { Title } = Typography;

export default function SeuView(props) {
  const { siteID } = props;

  const [loading, setLoading] = useState(false);

  const [fetchWrapper] = useFetch();

  const [isAddSeuModalOpen, setIsAddSeuModalOpen] = useState(false);
  const [isEditSeuModalOpen, setIsEditSeuModalOpen] = useState(false);
  const [selectedInfoSeu, setSelectedInfoSeu] = useState(null);

  const [seuDetails, setSeuDetails] = useState([]);
  const [selectedEditSeu, setSelectedEditSeu] = useState(null); // this selected ser is the seu to be edited

  // load index context
  const { messageApi } = useContext(IndexContext);

  /* API to get seu details */
  function getSeuDetails() {
    setLoading(true);
    fetchWrapper({
      endpoint_url: "site_management/getSeuDetails",
      body: {
        site_id: siteID,
      },
      onSuccess: (fetch_output) => {
        setLoading(false);
        if (fetch_output.status === true) {
          setSeuDetails(fetch_output.seu_details);
        }
      },
    });
  }

  /* API to delete seu */
  function deleteSeu(seu_id) {
    setLoading(true);

    fetchWrapper({
      endpoint_url: "site_management/deleteSeu",
      body: {
        seu_id: seu_id,
      },
      onSuccess: (fetch_output) => {
        setLoading(false);

        if (fetch_output.status === true) {
          messageApi.open({
            type: "success",
            content: fetch_output.message,
          });
          getSeuDetails();
          setSelectedInfoSeu(null);
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.error,
          });
        }
      },
    });
  }

  useEffect(() => {
    getSeuDetails();
  }, [siteID]);

  return (
    <div className="list-view" style={{ height: "100%" }}>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={10} xl={10}>
          <div className="mb-2">
            <Title level={3} className="mt-0">
              SEU
            </Title>
            <Button
              icon={<PlusOutlined />}
              className="mb-5"
              style={{ width: "100%" }}
              onClick={() => setIsAddSeuModalOpen(true)}
            >
              New SEU
            </Button>

            {loading ? (
              <Skeleton />
            ) : (
              <List
                dataSource={seuDetails}
                size="large"
                renderItem={(item) => (
                  <List.Item
                    className={
                      selectedInfoSeu?.ID == item.ID
                        ? "ant-list-item list-item-selected"
                        : "ant-list-item list-item"
                    }
                    onClick={() => {
                      setSelectedInfoSeu(item);
                    }}
                  >
                    <Flex
                      justify="space-between"
                      style={{
                        width: "100%",
                      }}
                    >
                      <div>{item.Name}</div>

                      <Flex gap={8}>
                        <div className="mr-2">
                          <Tooltip title="Edit">
                            <EditOutlined
                              onClick={() => {
                                setSelectedEditSeu(item);
                                setIsEditSeuModalOpen(true);
                              }}
                              style={{
                                color:
                                  selectedInfoSeu?.ID == item.ID
                                    ? "var(--ant-color-white)"
                                    : "var(--ant-color-primary)",
                              }}
                            />
                          </Tooltip>
                        </div>

                        <div>
                          <Tooltip title="Delete">
                            <Popconfirm
                              title="Delete SEU"
                              description={"Are you sure to delete this SEU?"}
                              onConfirm={() => {
                                deleteSeu(item.ID);
                              }}
                              okText="Yes"
                              cancelText="No"
                            >
                              <DeleteOutlined
                                style={{ color: "var(--ant-color-error)" }}
                              />
                            </Popconfirm>
                          </Tooltip>
                        </div>
                      </Flex>
                    </Flex>
                  </List.Item>
                )}
              />
            )}
          </div>
        </Col>

        <Col xs={24} sm={24} md={24} lg={10} xl={10}>
          <SeuDetails selectedSeu={selectedInfoSeu} />
        </Col>
      </Row>

      <Modal
        title="Add SEU"
        open={isAddSeuModalOpen}
        footer={null}
        closable={false}
        destroyOnClose={true}
        maskClosable={false}
      >
        <Divider className="mb-4 mt-0"></Divider>
        <SeuForm
          mode="add"
          setIsSeuFormModalOpen={setIsAddSeuModalOpen}
          siteID={siteID}
          refreshList={getSeuDetails}
        />
      </Modal>

      <Modal
        title="Edit SEU "
        open={isEditSeuModalOpen}
        footer={null}
        closable={false}
        destroyOnClose={true}
        maskClosable={false}
      >
        <Divider className="mb-4 mt-0"></Divider>
        <SeuForm
          mode="edit"
          setIsSeuFormModalOpen={setIsEditSeuModalOpen}
          siteID={siteID}
          refreshList={getSeuDetails}
          initialValues={selectedEditSeu}
          setSelectedInfoSeu={setSelectedInfoSeu}
        />
      </Modal>
    </div>
  );
}
